import styled from "@emotion/styled/macro";
import { TypographyT29, TypographyT30, TypographyT31 } from "Components/Common/Typography/index";
import React, { Fragment } from "react";
import moment from "moment";

const BidDetailsTableInformation = (props) => {
  const {
    bid_record_details = []
  } = props;
  return (
    <TableWrapper>
      <Table>
        <THead>
          <Tr>
            <Th></Th>
            <Th>
              <TypographyT29 variant="h5">RFQ No.</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5">Contract Tenure Date (From - To)</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5">Vehicle Type</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5">Vehicle Capacity</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5">Price</TypographyT29>
            </Th>
          </Tr>
        </THead>
        <TBody>
          {bid_record_details.map((eleOFBRD, indOfBRD, BRD) => {
            return <Fragment key={indOfBRD}>
              <Tr>
                <Td>
                  <TypographyT30 variant="h6">{indOfBRD + 1}</TypographyT30>
                </Td>
                <Td>
                  <TypographyT31 variant="h5">{eleOFBRD.rfq_number}</TypographyT31>
                </Td>
                <Td>
                  <TypographyT31 variant="h5">
                   {`${!!eleOFBRD.contract_tenure_from
                   ?moment(eleOFBRD.contract_tenure_from).format("DD/MM/YYYY")
                   :"-"
                   } - 
                   ${!!eleOFBRD.contract_tenure_to
                    ?moment(eleOFBRD.contract_tenure_to).format("DD/MM/YYYY")
                    :"-"
                    }
                   `}
                  </TypographyT31>
                </Td>
                <Td>
                  <TypographyT31 variant="h5">{eleOFBRD.vehicle_type_name}</TypographyT31>
                </Td>
                <Td>
                  <TypographyT31 variant="h5">{eleOFBRD.vehicle_capacity}</TypographyT31>
                </Td>
                <Td>
                  <TypographyT31 variant="h5">{`${eleOFBRD.price} (${eleOFBRD.pricing_basis_name})`}</TypographyT31>
                </Td>
              </Tr>
              {(BRD.length === indOfBRD + 1) && <Fragment>
                <Tr>
                  <Td1
                    colSpan={4}
                  >
                  </Td1>
                  <Td1 >
                    <TypographyT31 variant="h5">
                      Total
                    </TypographyT31>
                  </Td1>

                  <Td1>
                    <TypographyT31 variant="h5">{eleOFBRD.sum_of_bid_price}</TypographyT31>
                  </Td1>
                </Tr>
              </Fragment>}
            </Fragment>
          })
          }
        </TBody>
      </Table>
    </TableWrapper>
  );
};

export default BidDetailsTableInformation;

const TableWrapper = styled.div`
  overflow: auto;
  box-shadow: 0px 0px 10px 0px rgba(82, 138, 234, 0.36);
  border-radius: 5px;
`;

const Table = styled.table`
  width: 100%;
  border-spacing: 0px;
  border-radius: 5px;
  background: #fff;
`;
const THead = styled.thead``;
const TBody = styled.tbody``;
const Th = styled.th`
  text-align: left;
  background-color: #e7edfa;
  padding: 10px;
`;
const Td = styled.td`
  padding: 10px;
  background-color: #fff;
`;

const Tr = styled.tr`
  &:first-of-type ${Td} {
    border-bottom: 1px solid #e7edfa;
  }
`;

const Td1 = styled(Td)`
  background-color:#E7EDFA;
`;